'use client';

import React, { useState, useEffect } from 'react';
import FeaturedArticles from './FeaturedArticles';
import dynamic from 'next/dynamic';
import WindowSize from '@/utils/windowSize';

const CtaBox = dynamic(() => import('./CtaBox'));

const ArticleSidebar = ({ sidebarBlocks, featuredArticles }) => {
  const windowSize = WindowSize();
  const [desktop, setDesktop] = useState(false);

  useEffect(() => {
    if (windowSize.width > 1023) {
      setDesktop(true);
    } else {
      setDesktop(false);
    }
  }, [windowSize]);

  return (
    <div id="article-sidebar" className={`pl-0 lg:mb-15 lg:pl-8`}>
      {windowSize.width > 1023 || desktop ? (
        <div className="sticky top-20 w-full">
          {sidebarBlocks?.map((block, index) =>
            block.cta_box ? (
              Object.keys(block)[0] === 'cta_box' ? (
                <CtaBox key={`section-${index}`} block={block} />
              ) : (
                <div key={`section-${index}`}></div>
              )
            ) : (
              <div key={`section-${index}`}>{Object.keys(block)[1]}</div>
            )
          )}
          <FeaturedArticles
            featuredArticles={featuredArticles}
            sidebarBlocksExist={sidebarBlocks?.length > 0}
          />
        </div>
      ) : (
        <div className="mx-4 sm:mx-0">
          {sidebarBlocks?.map((block, index) => {
            switch (Object.keys(block)[1]) {
              case 'cta_box':
                return <CtaBox key={`section-${index}`} block={block} />;
              default:
                return <div key={`section-${index}`}></div>;
            }
          })}
          <FeaturedArticles
            featuredArticles={featuredArticles}
            sidebarBlocksExist={sidebarBlocks?.length > 0}
          />
        </div>
      )}
    </div>
  );
};

export default ArticleSidebar;
